// Next Diamonds — PDP engraving → cart-form mirror + Save feedback
//
// The engraving snippet renders OUTSIDE the cart-add form (it's a custom
// section block). So a raw `name="properties[Engraving]"` input wouldn't
// actually be submitted with Add to Cart. We mirror the visible input's
// value into a hidden input that lives INSIDE every cart-add form.
//
// The Save button gives explicit visual confirmation that the engraving
// is locked in for Add to Cart.

(function () {
  'use strict';

  function findCartForms() {
    return document.querySelectorAll(
      'form[action*="/cart/add"], product-form form, form[action$="/cart/add"]'
    );
  }

  function ensureHidden(form) {
    var existing = form.querySelector('input[type="hidden"][name="properties[Engraving]"]');
    if (existing) return existing;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Engraving]';
    form.appendChild(input);
    return input;
  }

  function syncAll(value) {
    findCartForms().forEach(function (form) {
      var hidden = ensureHidden(form);
      if (!value) {
        hidden.value = '';
        hidden.disabled = true;
      } else {
        hidden.value = value;
        hidden.disabled = false;
      }
    });
  }

  function setFeedback(showSaved) {
    var defaultEl = document.querySelector('[data-nd-engraving-default]');
    var savedEl = document.querySelector('[data-nd-engraving-feedback]');
    if (!defaultEl || !savedEl) return;
    if (showSaved) {
      defaultEl.hidden = true;
      savedEl.hidden = false;
    } else {
      defaultEl.hidden = false;
      savedEl.hidden = true;
    }
  }

  function init() {
    var src = document.querySelector('[data-nd-engraving-input]');
    if (!src) return;
    var saveBtn = document.querySelector('[data-nd-engraving-save]');

    function handleInput() {
      // Live mirror so the property is always in sync with what's typed
      syncAll((src.value || '').trim());
      // If the user edits AFTER saving, revert feedback so they know to save again
      if (saveBtn && saveBtn.classList.contains('is-saved')) {
        saveBtn.classList.remove('is-saved');
        saveBtn.textContent = 'Save';
        setFeedback(false);
      }
    }

    function handleSave() {
      var value = (src.value || '').trim();
      syncAll(value);
      if (saveBtn) {
        saveBtn.classList.add('is-saved');
        saveBtn.textContent = '✓ Saved';
      }
      setFeedback(!!value);
      // After 2.4s revert button label but keep the saved-state class
      setTimeout(function () {
        if (saveBtn && saveBtn.classList.contains('is-saved')) {
          saveBtn.textContent = 'Saved';
        }
      }, 2400);
    }

    src.addEventListener('input', handleInput);
    src.addEventListener('change', handleInput);
    if (saveBtn) saveBtn.addEventListener('click', handleSave);

    // Initial sync (handles pre-filled values + late-mounted forms)
    handleInput();
    setTimeout(function () { syncAll((src.value || '').trim()); }, 500);
    setTimeout(function () { syncAll((src.value || '').trim()); }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
